import { v4 as uuidv4 } from 'uuid'

export const PAGE_SESSION_ID = uuidv4()
